import Modality from "./Modality";
import {keys} from "../config/nameSpacesKeys";

export default class ModalityList {
  constructor(name, initialValue=[], namespace) {
    this.namespace=namespace;
    this.name=name;

    this.list=[];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.list;
  }

  setObjList(fList) {
    this.list = fList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.list.length) {
      return;
    }
    this.list.splice(index, 1);
  }

  addValueObj(obj) {
    const newObj=new Modality(this.name, obj, this.namespace, keys.msmediaType);
    this.list.push(newObj);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      if (!obj && this.isEditor) { // if it is undefined - either it is empty coming from editor ,
        // either it is empty coming from landing page. both need different handling
        this.addValueObj(obj);
      }
    }
  }

  print() {
    for (let i=0; i<this.list.length; i++) {
      this.list[i].print();
    }
  }

  clear() {
    this.list = [];
  }

  getExpandedFormatValue() {
    const expandedList=[];
    for (let index=0; index<this.list.length; index++) {
      const item=this.list[index];
      if (!item.isEmpty()) {
        expandedList.push(item.getExpandedFormatValue());
      }
    }
    return expandedList;
  }

  isEmpty() {
    let condition=true;
    for (let index=0; index<this.list.length; index++) {
      const item=this.list[index];
      condition=condition&&item.isEmpty();
    }
    return condition;
  }
}
